module.exports = {
      id: "icon-person-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-person",
      toString: function () {
        return this.url;
      }
    }